import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';
import { getBearerAuthHeaders } from './authFetchHeaders';
import { useAuth } from '../contexts/AuthContext';

/**
 * Is the signed-in person a self user (not part of a company)? True when they
 * have no company brand, or are on RiskLo's own home brand. Self users get the
 * welcome Overview and dashboards built from their own accounts; company members
 * get their company's dashboard (and can still build their own).
 *
 * One /api/entities/me call per page load, shared by every caller.
 */
let mePromise = null;
let meFor = null;

function loadMe() {
  // Keyed to the session, so a different person signing in never reuses the answer.
  const session = (() => { try { return localStorage.getItem('risklo_auth_token') || ''; } catch { return ''; } })();
  if (meFor !== session) { mePromise = null; meFor = session; }
  if (!mePromise) {
    mePromise = fetch(`${API_BASE_URL}/api/entities/me`, { headers: getBearerAuthHeaders() })
      .then((r) => r.json())
      .catch(() => ({}));
  }
  return mePromise;
}

export function resetWorkspace() {
  mePromise = null;
}

export function useWorkspace(signedIn = true) {
  // A Platform Admin previewing Self-use Basic/Pro/Max sees the self-user app.
  const { isSelfUsePreview } = useAuth();
  const [state, setState] = useState({ loading: Boolean(signedIn), selfUser: false });
  useEffect(() => {
    if (!signedIn) { setState({ loading: false, selfUser: false }); return undefined; }
    let live = true;
    loadMe().then((data) => {
      if (!live) return;
      const active = data?.activeEntity || null;
      const selfUser = !active || String(active.slug || '').toLowerCase() === 'risklo';
      setState({ loading: false, selfUser, isFullAdmin: Boolean(data?.isFullAdmin) });
    });
    return () => { live = false; };
  }, [signedIn]);
  if (isSelfUsePreview && signedIn) return { loading: false, selfUser: true, isFullAdmin: true };
  return state;
}
